import React, { useEffect, useRef, useState } from 'react';
import { Link } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';

const Edit = ({ show, onClose }) => {
    const [isDisVisible, setIsDisVisible] = useState({
        alldays: true,
        specification: false
    });
    const DistoggleDiv = (section) => {
        setIsDisVisible((prev) => ({
            alldays: section === 'alldays',
            specification: section === 'specification',
        }));
    };
    return (
        <Modal className="modal fade" show={show} size="md">
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#b7dfd0' }}>
                    <h3 className="modal-title">Update Package Timeline</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span>×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Package Timeline<span className="required">*</span></label>
                            <input type="text" className="form-control" placeholder="Enter Package Timeline" defaultValue={'weekly'}/>
                        </div>
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">No Of Days<span className="required">*</span></label>
                            <input type="text" className="form-control" placeholder="Enter No Of Days"  defaultValue={'7'}/>
                        </div>
                        <div className="col-lg-12">
                            <div className='mb-4 mt-2'>
                                <div className="form-check-inline">
                                    <input
                                        className="form-check-input me-1"
                                        type="radio"
                                        name="product_type"
                                        value="option1"
                                        checked={isDisVisible.alldays}
                                        onClick={() => DistoggleDiv('alldays')}
                                        defaultChecked
                                    />
                                    <label className="form-check-label text-black font-w500 fs-7">
                                        All Days
                                    </label>
                                </div>
                                <div className="form-check-inline">
                                    <input
                                        className="form-check-input me-1"
                                        type="radio"
                                        name="product_type"
                                        value="option2"
                                        checked={isDisVisible.specification}
                                        onClick={() => DistoggleDiv('specification')}
                                    />
                                    <label className="form-check-label text-black font-w500 fs-7">
                                        Specification
                                    </label>
                                </div>
                                <div className='row mt-2'>
                                    {isDisVisible.specification && (
                                        <>
                                            <div className='col-lg-6 mb-2 d-flex align-items-center'>
                                                <input
                                                    className="form-check-input me-3"
                                                    type="checkbox"
                                                    name="sun"
                                                    value="week_days"
                                                />
                                                <label className="fs-7 text-black font-w500 mt-1">
                                                    Sunday
                                                </label>
                                            </div>
                                            <div className='col-lg-6 mb-2 d-flex align-items-center'>
                                                <input
                                                    className="form-check-input me-3"
                                                    type="checkbox"
                                                    name="mon"
                                                    value="week_days"
                                                />
                                                <label className="fs-7 text-black font-w500 mt-1">
                                                    Monday
                                                </label>
                                            </div>
                                            <div className='col-lg-6 mb-2 d-flex align-items-center'>
                                                <input
                                                    className="form-check-input me-3"
                                                    type="checkbox"
                                                    name="tue"
                                                    value="week_days"
                                                />
                                                <label className="fs-7 text-black font-w500 mt-1">
                                                    Tuesday
                                                </label>
                                            </div>
                                            <div className='col-lg-6 mb-2 d-flex align-items-center'>
                                                <input
                                                    className="form-check-input me-3"
                                                    type="checkbox"
                                                    name="wed"
                                                    value="week_days"
                                                />
                                                <label className="fs-7 text-black font-w500 mt-1">
                                                    Wednesday
                                                </label>
                                            </div>
                                            <div className='col-lg-6 mb-2 d-flex align-items-center'>
                                                <input
                                                    className="form-check-input me-3"
                                                    type="checkbox"
                                                    name="thurs"
                                                    value="week_days"
                                                />
                                                <label className="fs-7 text-black font-w500 mt-1">
                                                    Thursday
                                                </label>
                                            </div>
                                            <div className='col-lg-6 mb-2 d-flex align-items-center'>
                                                <input
                                                    className="form-check-input me-3"
                                                    type="checkbox"
                                                    name="fri"
                                                    value="week_days"
                                                />
                                                <label className="fs-7 text-black font-w500 mt-1">
                                                    Friday
                                                </label>
                                            </div>
                                            <div className='col-lg-6 mb-2 d-flex align-items-center'>
                                                <input
                                                    className="form-check-input me-3"
                                                    type="checkbox"
                                                    name="sat"
                                                    value="week_days"
                                                />
                                                <label className="fs-7 text-black font-w500 mt-1">
                                                    Saturday
                                                </label>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-center gap-3 mt-4">
                        <Link type="reset" className="btn btn-sm btn-secondary" onClick={onClose}>Cancel</Link>
                        <Link type="submit" className="btn btn-sm btn-primary" onClick={onClose}>Update Package Timeline</Link>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default Edit;